import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAttendanceHomeList } from "../../Thunks/HeyTraderThunks";
import { AttendanceHomeType } from "../../Types/HeyTraderTypes/Attendances/AttendanceHomeType";


interface AttendanceHomeListSliceState {
    loader: boolean; // for refres pages and inital loadings
    attendanceHomeList: AttendanceHomeType [];
    errorDisplay: string | null;
}

// set inital valus
const initialState : AttendanceHomeListSliceState = {
    loader: false,
    attendanceHomeList: [],
    errorDisplay: '',

}

// set state valu for api response
const attendanceHomeSlice = createSlice ({
    name: 'attendanceHome',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAttendanceHomeList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAttendanceHomeList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAttendanceHomeList.fulfilled, (state, action: PayloadAction<AttendanceHomeType[]>) => {
                    state.loader = false;
                    state.attendanceHomeList = action.payload;
                  })
    }
})

export const {} = attendanceHomeSlice.actions
export default attendanceHomeSlice.reducer
